import { defineMessages } from 'react-intl'

const messages = {
    logIn: {
        id: 'app.components.login-form.log-in',
        defaultMessage: 'Log in',
    },
    email: {
        id: 'app.components.login-form.email',
        defaultMessage: 'Username',
    },
    password: {
        id: 'app.components.login-form.password',
        defaultMessage: 'Password',
    },
    incorrectEmail: {
        id: 'app.components.login-form.incorrect-email',
        defaultMessage: 'Incorrect email',
    },
    incorrectPassword: {
        id: 'app.components.login-form.incorrect-password',
        defaultMessage: 'Incorrect password',
    },
    incorrectForm: {
        id: 'app.components.login-form.incorrect-form',
        defaultMessage: 'The username or password is incorrect',
    },
    forgotPasswordMessage: {
        id: 'app.components.login-form.forgot-password',
        defaultMessage: 'Forgot password?',
    },
}

export default defineMessages(messages)
